// extracted by mini-css-extract-plugin
export default {"reviewDetails":"style--reviewDetails--6904ca","treatmentRating":"style--treatmentRating--675e94","buttonContainer":"style--buttonContainer--20ddd8"};